import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const SalesApi = createApi({
    reducerPath: "SalesApi",
    baseQuery: fetchBaseQuery({
        baseUrl: import.meta.env.VITE_API_URL + "/sales",
        credentials: 'include',
        prepareHeaders: (headers) => {
            const token = localStorage.getItem('_at') || null;
            if (token) {
                headers.set("Authorization", "Bearer " + token);
            }
            return headers;
        }
    }),
    tagTypes: ['Sales'],
    endpoints: (builder) => ({
        salesOverview: builder.query({
            query: ({ from = '', to = '' } = {}) => {
                const params = new URLSearchParams();
                if (from) params.append('from', from);
                if (to) params.append('to', to);
                const queryString = params.toString();
                return `/sales-overview${queryString ? `?${queryString}` : ''}`;
            },
            providesTags: ['Sales']
        }),
        salesTrend: builder.query({
            query: ({ from = '', to = '' } = {}) => {
                const params = new URLSearchParams();
                if (from) params.append('from', from);
                if (to) params.append('to', to);
                const queryString = params.toString();
                return `/sales-trend${queryString ? `?${queryString}` : ''}`;
            },
            providesTags: ['Sales']
        }),
        topProducts: builder.query({
            query: ({ sortBy = 'revenue', from = '', to = '' } = {}) => {
                const params = new URLSearchParams();
                if (sortBy) params.append('sortBy', sortBy);
                if (from) params.append('from', from);
                if (to) params.append('to', to);
                return `/top-products?${params.toString()}`;
            },
            providesTags: ['Sales']
        }),
        orderStatus: builder.query({
            query: ({ from = '', to = '' } = {}) => {
                const params = new URLSearchParams();
                if (from) params.append('from', from);
                if (to) params.append('to', to);
                const queryString = params.toString();
                return `/orders-status${queryString ? `?${queryString}` : ''}`;
            },
            providesTags: ['Sales']
        }),
    })
});

export const { 
    useSalesOverviewQuery, 
    useSalesTrendQuery, 
    useTopProductsQuery, 
    useOrderStatusQuery 
} = SalesApi;